import React, { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";

import PrimaryButton from "../../../../../../components/buttons/PrimaryButton";
import Input from "../../../../../../components/inputs/Input";
import { useAuthLoginAgents } from "../../../../../../services/microservice/micelu/auth/use-auth-micelu";
import { useLoginUser } from "../../../../../../hooks/useLoginUser";
import { useAgentsAdminContext } from "../../../providers/agents-admin.provider";

type IFormInput = {
  code: string;
};

const codeSchema = yup.object({
  code: yup
    .string()
    .matches(/^\d+$/, { message: " Solo acepta números" })
    .required(" Requerido"),
});

const CodeStep = () => {
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(codeSchema),
  });
  const { login } = useLoginUser();
  const [error, setError] = useState<string>("");
  const { mutateAsync: login2FA, isLoading } = useAuthLoginAgents();
  const { setUser, setStep, user, sponsor } = useAgentsAdminContext();
  const navigate = useNavigate();

  const onSubmit = async (val: IFormInput) => {
    try {
      const res = await login2FA({
        email: user?.email,
        password: user?.password,
        sponsorID: sponsor.toUpperCase(),
        otp: val.code,
      });
      if (res.data.shouldChangePassword) {
        login(res.data, false);
        setStep(3);
      } else {
        navigate(`/${sponsor}/admin/home`);
        login(res.data, false);
        setError("");
      }
    } catch (error) {
      setError("Ocurrió un error inesperado");
    }
  };

  const handlePreviousStep = () => {
    setStep(1);
    setUser(null);
  };
  return (
    <section className="flex h-full w-full items-center justify-center p-0 pt-20">
      <div className="container w-1/2 px-4 py-20 lg:px-20">
        <div className="mt-10 rounded-xl bg-white py-20 shadow-xl lg:px-10">
          <h2 className="mb-5 text-center text-3xl font-bold">
            <span>Código de verificación</span>
          </h2>
          {error && <p className="text-md text-critical">{error}</p>}
          <div className="mb-10 w-full">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Controller
                name="code"
                control={control}
                render={({ field }) => (
                  <Input
                    {...field}
                    classNameContainer="w-full mb-7"
                    classNameInput="w-full"
                    placeholder="Código de verifación"
                    error={errors.code?.message}
                    required
                  />
                )}
              />
              <div className="flex w-full justify-between">
                <PrimaryButton
                  title="Atrás"
                  type="button"
                  className={"mt-5 rounded-3xl border px-5 py-1 text-textBlack"}
                  style={{ borderColor: "#0a0a0a" }}
                  onClick={() => handlePreviousStep()}
                />
                <PrimaryButton
                  title="Verificar código"
                  className={
                    "mt-5 rounded-3xl bg-buttonBlack px-5 py-1 text-sm font-normal text-whiteSoft"
                  }
                  loading={isLoading}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CodeStep;
